// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"3d84783c","181":"2273d970","202":"adf0d56c","252":"99488ce2","544":"31d6cfe0","552":"716295a9","673":"31d6cfe0","681":"a7ac10dd","722":"31d6cfe0","879":"31d6cfe0","970":"8c40522e","982":"31d6cfe0"}[chunkId] + ".chunk.css";
};